module.exports = __webpack_public_path__ + "img/meditatin.e22f2997.svg";